import Button from "components/base/Button";
import { Text } from "components/base/Form";
import { Alert } from "components/base/Toast";
import useSendEmail from "hooks/useSendEmail";
import { useState } from "react";

const EmailForm = ({ subject, to, initialMessage, hide }) => {
  const [message, setMessage] = useState(initialMessage);
  const [send, sendRes] = useSendEmail();

  function sendHandler() {
    send({
      variables: { subject, to, message },
      onCompleted() {
        Alert("success", "Invitation email sent successfully.");
        if (hide) hide();
      },
    });
  }

  return (
    <div>
      <div className="flex items-center space-x-3">
        <label>Email to: </label>
        <span>{to.join(", ")}</span>
      </div>

      <div className="-mx-[2px] mt-4">
        <Text value={message} onChange={(e) => setMessage(e.target.value)} />
      </div>

      <div className="mt-4">
        <Button primary send onClick={sendHandler} loading={sendRes.loading}>
          Send
        </Button>
      </div>
    </div>
  );
};

export default EmailForm;
